export default __webpack_public_path__ + "static/media/roller7.9e4d4c5d.gif";